import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { TaskCompletion } from '../../tasks/models';
import { useIntl } from 'react-intl';
import { showDialog } from '../../../core/actions';
import { selectCurrentEmployee, selectTasks } from '../reducer';
import { snoozeTaskCompletion } from '../../overview/actions';
import { addTask, fetchTasks, getTask } from '../actions';

interface ModalProps {
  isOpen: boolean;
  close: any;
  taskCompletion: TaskCompletion;
  onSnooze: any;
}

const SnoozeTaskModal = ({ isOpen, close, taskCompletion, onSnooze }: ModalProps): JSX.Element => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [createProject, setCreateProject] = useState(false);
  const [snoozeReason, setSnoozeReason] = useState('');
  const currentEmployee = useSelector(selectCurrentEmployee);
  const tasks = useSelector(selectTasks);

  const task = tasks.find((t: any) => t.id === taskCompletion?.taskId);

  const submitProject = (t: any) => {
    dispatch(
      addTask({
        task: t,
        callback: onSnooze,
      })
    );
  };

  const completeSnooze = () => {
    dispatch(
      snoozeTaskCompletion({
        employeeId: currentEmployee,
        taskIds: [taskCompletion?.id],
        notes: snoozeReason,
        closeModal: !createProject,
        callback: createProject
          ? undefined
          : [onSnooze, () => (taskCompletion?.taskId ? getTask(taskCompletion.taskId) : null)],
      })
    );
    if (createProject) {
      const defaultTask: any = {
        type: 1,
        interval: 1,
      };
      if (taskCompletion?.task) {
        defaultTask.linkedTasks = [
          {
            dependency: 'RelatesTo',
            linkedTaskId: task.id,
          },
        ];
      }
      dispatch(
        showDialog('UPSERT_TASK', {
          title: intl.formatMessage({
            id: 'addNewWorkOrder',
            defaultMessage: 'Add New Work Order',
          }),
          onSubmit: submitProject,
          isNew: true,
          taskDefaults: defaultTask,
        })
      );
    } else {
      if (close) close();
    }
  };

  useEffect(() => {
    if (tasks.length == 0) {
      dispatch(fetchTasks());
    }
  }, [tasks.length]);

  return (
    <Modal isOpen={isOpen} toggle={close} className="enhanced-dialog narrow padded-minimal">
      <ModalHeader toggle={close}>{intl.formatMessage({ id: 'blockTask' })}</ModalHeader>
      <ModalBody data-testid="modal">
        <div className="snooze-modal">
          <p>{task?.name}</p>
          <p>{intl.formatMessage({ id: 'enterBlockReason' })}</p>
          <div className="form-group">
            <textarea
              name="reason"
              id="reason"
              defaultValue={snoozeReason}
              onChange={(e) => setSnoozeReason(e.target.value)}
            />
            {/* <label className="no-select">
              <input
                name="createProject"
                type="checkbox"
                defaultChecked={createProject}
                onChange={() => setCreateProject(!createProject)}
              />
              {intl.formatMessage({ id: 'createNewLinked' })}
            </label> */}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="full-width">
        <Button className="submit-button delete" color="secondary" onClick={close}>
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button
          className="submit-button confirm"
          color="primary"
          onClick={completeSnooze}
          disabled={snoozeReason == ''}
        >
          {intl.formatMessage({ id: 'blockTask' })}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SnoozeTaskModal;
